import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "第三方软件信息", -1)

import { SoftInfoState } from '@/store/modules/softInfo/types';
import { softInfoAPI } from '@/api/softInfo';
import { useRoute } from 'vue-router';
import { computed, onMounted, onUnmounted, ref } from 'vue';


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "SoftInfoWindow",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);

const softInfoState = ref({
    softInfos: {},
    isLoading: false,
} as SoftInfoState)

const isDataEmpty = (data: string): string => {
    if (data === "no path" || data === "nopath") {
        return "暂无"
    } else {
        return data
    }
}

onMounted(async () => {
    softInfoState.value.isLoading = true
    try {
        const projId = projectId.value
        const uid = targetId.value;
        const Response = await softInfoAPI.getSoftInfoListByUid(projId, uid);
        softInfoState.value.softInfos = Response[0];
    } catch (err) {
        console.log(err);
    } finally {
        softInfoState.value.isLoading = false;
    }
})



return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _withDirectives((_openBlock(), _createElementBlock("div", null, [
      (softInfoState.value.softInfos !== undefined)
        ? (_openBlock(), _createBlock(_component_el_descriptions, {
            key: 0,
            direction: "horizontal",
            column: 2,
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_descriptions_item, { label: "微信ID" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(isDataEmpty(softInfoState.value.softInfos.WeChatID)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "微信名" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(isDataEmpty(softInfoState.value.softInfos.WeChatName)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "网易云音乐" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(isDataEmpty(softInfoState.value.softInfos.WangYiYun)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "泡泡聊天" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(isDataEmpty(softInfoState.value.softInfos.PaoPao)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "酷狗" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(isDataEmpty(softInfoState.value.softInfos.KuGou)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "QQ音乐" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(isDataEmpty(softInfoState.value.softInfos.QQMusic)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "QQ音乐2" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(isDataEmpty(softInfoState.value.softInfos.QQMusic2)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "QQ" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(isDataEmpty(softInfoState.value.softInfos.QQ)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            description: "description",
            class: "description-hardware"
          }))
    ])), [
      [_directive_loading, softInfoState.value.isLoading]
    ])
  ], 64))
}
}

})